import React from "react";
import { Typography } from "@mui/material";
import { InscricoesBase } from "../Components/InscricoesBase";
import { apenasProdutosExclusivos } from "../utils/produtoFilters";

/**
 * Página de inscrições EXCLUSIVA.
 *
 * Não é listada no menu principal (ver NavBar) — o link é repassado
 * manualmente para pessoas selecionadas via a rota `/inscricoes-exclusivas`.
 *
 * Exibe apenas os produtos exclusivos (R$ 2,00). A regra de filtragem é
 * compartilhada com a página pública em `utils/produtoFilters`.
 */

// Aviso explícito exibido no topo da página, comunicando que esta inscrição é
// restrita a pessoas previamente selecionadas.
const AVISO_EXCLUSIVO = (
  <>
    <Typography component="span" sx={{ fontWeight: "bold" }}>
      Atenção: inscrição reservada a pessoas selecionadas.
    </Typography>{" "}
    Este tipo de inscrição é destinado exclusivamente a pessoas que já fazem
    parte de uma relação prévia. Caso uma inscrição seja realizada por este link
    sem que a pessoa conste nessa relação, a inscrição será{" "}
    <Typography component="span" sx={{ fontWeight: "bold" }}>
      cancelada
    </Typography>
    , sendo necessário realizar uma nova inscrição e pagar novamente o valor
    devido.
  </>
);

export const InscricoesExclusivas = () => {
  return (
    <InscricoesBase
      filtrarProdutos={apenasProdutosExclusivos}
      titulo="Inscrições reservadas"
      aviso={AVISO_EXCLUSIVO}
    />
  );
};

export default InscricoesExclusivas;
